import classnames from 'classnames'
import { Button } from '@platform/ui-kit'
import { DownloadIcon } from '@icons'

import { GraphicLinesTwo } from '../../../assets/icons'

import styles from './index.module.scss'
type PressGuidelinesCardProps = {
  className?: string
}

export const PressGuidelinesCard = ({ className }: PressGuidelinesCardProps) => {
  return (
    <div className={classnames(styles['card-wrapper'], className)}>
      <div className={styles['content-wrapper']}>
        <h2 className={styles['title']}>Media Kit and Brand Guidelines</h2>
        <Button
          size="large"
          variant="on-brand"
          startAdornment={DownloadIcon}
          className={styles['button']}
          href="https://platform-statics.olby.com/media-kit.zip"
          isExternal
        >
          Download Media Kit
        </Button>
        <Button
          size="large"
          variant="on-brand"
          startAdornment={DownloadIcon}
          className={styles['brand-guidelines']}
          href="https://platform-statics.olby.com/brandbook-olby-out-2022.pdf"
          isExternal
          target="_blank"
        >
          Download Brand Guidelines
        </Button>
      </div>
      <GraphicLinesTwo className={styles['graphic-lines']} />
    </div>
  )
}
